import { SelfPacedConditionalTopicFocusBtns } from "./SelfPacedConditionalTopicFocusBtns";
import "./index.scss";

interface IProps {
  segment: any;
  index?: number;
  handleRefreshModalOpen?: () => void;
}

export const SelfPacedConditionalBtns = ({ segment, index }: IProps): any => {
  return <SelfPacedConditionalTopicFocusBtns segment={segment} index={index} />;
};
